import { IApplicationState } from '../../types/redux';

export function getQuestionsIds(state: IApplicationState) {
  return state.questions.allIds;
}
